import { BaseReportComponent, ComponentConfigOption, PageOptionConfig, PageOrientation, ReportComponentType, ReportPageOption } from "@core/data/types/advanced-report";

// Carries a source component's data/config across a duplicate, so the new component is
// seeded with an exact copy instead of falling back to the type's blank defaults.
export interface SourceComponentOptions {
    data: any;
    config: ComponentConfigOption;
}

export class InitPageState {
    static readonly type = '[PageState] Initialise Page State';
    constructor (public pageKey: string, public reportKey: string, public shareKey: string = null) {}
}

export class SetComponentContext {
    static readonly type = '[PageState] Set Component Context';
    constructor(
        public componentKeys: string[],
    ) {}
}

export class NotifyReportState {
    static readonly type = '[PageState] Notify Report State';
    constructor() {}
}

export class AddReportComponent {
    static readonly type = '[PageState] Add Report Component';
    constructor(public pageKey: string, public data: Partial<BaseReportComponent>, public sourceOptions?: SourceComponentOptions) {}
}

export class AddComponentOptions {
    static readonly type = '[PageState] Add Component Options';
    constructor(
        public pageKey: string,
        public componentKey: string,
        public componentType: ReportComponentType,
        public componentKeys: string[],
        public sourceOptions?: SourceComponentOptions
    ) {}
}

export class RemoveComponentFromPage {
    static readonly type = '[PageState] Remove Component';
    constructor (public key: string, public componentKey: string) {}
}

export class EditPageOptions {
    static readonly type = '[PageState] Edit Page Options';

    // pageOptionsSnapshot: an already-known ReportPageOption, for callers (e.g.
    // ApplyReportPageOrientation) that captured it before an async gap. Lets the reducer persist
    // the edit even if PageState's live entity is momentarily unloaded when this dispatches.
    constructor (public key: string, public pageKey: string, public config: PageOptionConfig, public pageOptionsSnapshot?: ReportPageOption) {}
}

// In-memory sync only — no network call. For when a page's options were just created elsewhere
// (e.g. AddReportPageOptions' reactive fallback) and PageState needs to catch up without re-fetching,
// which risks racing back into whatever fallback created them in the first place.
export class SetPageOptions {
    static readonly type = '[PageState] Set Page Options';
    constructor (public pageKey: string, public options: ReportPageOption) {}
}

export class ApplyReportPageOrientation {
    static readonly type = '[PageState] Apply Report Orientation';
    constructor (public pageKeys: string[], public orientation: PageOrientation) {}
}